import { Stack, Typography } from '@mui/material';
import { FarePosition, farePositions } from '@silbo/core';
import { useTranslation } from 'react-i18next';
import { SelectableButton } from '../SelectableButton';

export function PositionStep({ value, onChange }: { value?: FarePosition; onChange: (value: FarePosition) => void }) {
  const { t } = useTranslation('patient-transport');

  return (
    <Stack gap={4}>
      <Typography>{t('reportIncident.steps.position.description')}</Typography>
      {farePositions.map((farePosition) => (
        <SelectableButton key={farePosition} isSelected={value === farePosition} onClick={() => onChange(farePosition)}>
          {t(`farePositions.${farePosition}`)}
        </SelectableButton>
      ))}
    </Stack>
  );
}
